const moneyPrefix = /Rs\.\s*/g;
const ignoredTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'OPTION']);

function replaceMoneyPrefixes(root) {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let node;

  while ((node = walker.nextNode())) {
    if (!ignoredTags.has(node.parentElement?.tagName) && moneyPrefix.test(node.nodeValue)) textNodes.push(node);
    moneyPrefix.lastIndex = 0;
  }

  textNodes.forEach((textNode) => {
    textNode.nodeValue = textNode.nodeValue.replace(moneyPrefix, '₹ ');
  });
}

function startCurrencyFormatting() {
  replaceMoneyPrefixes(document.body);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (!ignoredTags.has(node.parentElement?.tagName) && moneyPrefix.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(moneyPrefix, '₹ ');
          }
          moneyPrefix.lastIndex = 0;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          replaceMoneyPrefixes(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startCurrencyFormatting, { once: true });
} else {
  startCurrencyFormatting();
}
